import React, { useState, useEffect } from 'react';
//import './Principal.css';

const Hora = () => {
  const [horaActual, setHoraActual] = useState(new Date());

  useEffect(() => {
    // Configurar el intervalo para actualizar la hora cada segundo
    const intervalo = setInterval(() => {
      setHoraActual(new Date());
    }, 1000);

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(intervalo);
  }, []);

  return (
    <div className='hora' style={{  fontSize: '5rem', fontWeight: 'bold' , display: 'flex', flexDirection:'column', alignItems:'center'}}>
     <div>{horaActual.toLocaleTimeString()} </div>
    </div>
  );
};

export default Hora;